import { render, staticRenderFns } from "./OEM.vue?vue&type=template&id=64127061"
import script from "./OEM.vue?vue&type=script&lang=js"
export * from "./OEM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports